<template>
  <div>
    <div :class="viewMode == true ? 'grayscale' : ''">
      <div class="row col-12 cursor-pointer">
        <div class="table-responsive">
          <table class="table table-custom table-hover">
            <thead class="text-center">
              <tr>
                <td class="no-line dateStartCell cursor-default">{{ selectedStartDate === '01/01' ? 'Anual' :
                  selectedStartDate }}</td>
                <th v-for="(dato, index) of datos" :key="index" :id="`${id}-embalse-${index}`"
                  @mouseenter="columnHover(index, true)" @mouseleave="columnHover(index, false)">
                  <div class="cursor-default" style="width: 120px">

                    {{ dato.Nombre_Embalse }}

                  </div>

                </th>
              </tr>
            </thead>
            <tbody>
              <tr class="text-center">
                <th class="align-middle cursor-default">Capacidad</th>
                <td v-for="(dato, index) of datos" :key="index" :id="`${id}-capacidad-${index}`"
                  @mouseenter="columnHover(index, true)" @mouseleave="columnHover(index, false)">
                  <span class="cursor-default">{{ dato.capacidad.toFixed(3) }} hm<sup>3</sup></span>
                </td>
              </tr>
              <tr>
                <th class="align-middle cursor-default">Vol. min.</th>
                <td v-for="(dato, index) of datos" :key="index" :id="`${id}-volMin-${index}`"
                  @mouseenter="columnHover(index, true)" @mouseleave="columnHover(index, false)">
                  <div class="row">
                    <div class="col mb-2">
                      <input :disabled="viewMode == true ? true : false" type="text"
                        @input="calculateVol(index, 'volMin', $event)"
                        @blur="checkEmptyPercent(index, 'volMin', $event)" class="inputVolume"
                        :id="`${id}-volMinPercent-${index}`" /><span> %</span>
                    </div>
                    <div class="col">
                      <input :disabled="viewMode == true ? true : false" type="double"
                        v-model="dato[selectorFecha].volMin" @input="calculatePercent(index, 'volMin', $event)"
                        @blur="checkEmptyVolume(index, true, $event)" class="inputVolume" /><span> hm<sup>3</sup></span>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th class="align-middle cursor-default">Vol. max.</th>
                <td v-for="(dato, index) of datos" :key="index" :id="`${id}-volMax-${index}`"
                  @mouseenter="columnHover(index, true)" @mouseleave="columnHover(index, false)">
                  <div class="row">
                    <div class="col-12 mb-2">
                      <input :disabled="viewMode == true ? true : false" type="text"
                        @input="calculateVol(index, 'volMax', $event)"
                        @blur="checkEmptyPercent(index, 'volMax', $event)" class="inputVolume"
                        :id="`${id}-volMaxPercent-${index}`" /><span> %</span>
                    </div>
                    <div class="col-12">
                      <input :disabled="viewMode == true ? true : false" type="text"
                        v-model="dato[selectorFecha].volMax" @input="calculatePercent(index, 'volMax', $event)"
                        @blur="checkEmptyVolume(index, true, $event)" class="inputVolume" /><span> hm<sup>3</sup></span>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th class="align-middle cursor-default">Vol. min. util</th>
                <td v-for="(dato, index) of datos" :key="index" :id="`${id}-volMinUtil-${index}`"
                  @mouseenter="columnHover(index, true)" @mouseleave="columnHover(index, false)">
                  <div class="row">
                    <div class="col-12 mb-2">
                      <input :disabled="viewMode == true ? true : false" type="text"
                        @input="calculateVol(index, 'volMinUtil', $event)"
                        @blur="checkEmptyPercent(index, 'volMinUtil', $event)" class="inputVolume"
                        :id="`${id}-volMinUtilPercent-${index}`" /><span> %</span>
                    </div>
                    <div class="col-12">
                      <input :disabled="viewMode == true ? true : false" type="text"
                        v-model="dato[selectorFecha].volMinUtil" @input="calculatePercent(index, 'volMinUtil', $event)"
                        @blur="checkEmptyVolume(index, true, $event)" class="inputVolume" /><span> hm<sup>3</sup></span>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  data() {
    return {
      //Array que contiene el orden de los embalses según el standar de Emasesa
      list: [
        "Aracena", "Zufre", "Minilla", "Gergal", "Melonares", "Cala"
      ],
      //Array de datos locales (inicializado con valores test)
      datos: [
        {
          Nombre_Embalse: "Aracena",
          capacidad: 200,
          "01/01": { volMin: 30, volMax: 60 },
          "01/11": { volMin: 30, volMax: 60 },
        },
        {
          Nombre_Embalse: "Zufre",
          capacidad: 250,
          "01/01": { volMin: 90, volMax: 180 },
          "01/11": { volMin: 90, volMax: 180 },
        },
        {
          Nombre_Embalse: "Minilla",
          capacidad: 400,
          "01/01": { volMin: 185, volMax: 320 },
          "01/11": { volMin: 185, volMax: 320 },
        },
        {
          Nombre_Embalse: "Cala",
          capacidad: 620,
          "01/01": { volMin: 260, volMax: 490 },
          "01/11": { volMin: 260, volMax: 490 },
        },
        {
          Nombre_Embalse: "Gergal",
          capacidad: 380,
          "01/01": {
            volMin: 100,
            volMax: 260,
          },
          "01/11": {
            volMin: 100,
            volMax: 260,
          },
        },
        {
          Nombre_Embalse: "Melonares",
          capacidad: 1400,
          "01/01": {
            volMin: 470,
            volMax: 830,
          },
          "01/11": {
            volMin: 470,
            volMax: 830,
          },
        },
      ],
    };
  },


  components: {},
  props: {
    id: {
      type: String,
      default: ""
    },
    viewMode: {
      type: Boolean,
      default: false,
    },
    reusePlan: {
      type: Boolean,
      default: false,
    },
    selectedStartDate: {
      type: String,
      default: "",
    },
    altAvaDataset: {
      type: Array,
      default: []
    }
  },
  computed: {
    //Importamos la variable reactiva de vuex del año seleccionado por el usuario
    ...mapState("planner", [
      "v_capacity",
      "v_reusePlan",
      "v_updCapacity"
    ]),
    selectorFecha: function (val) {
      return this.selectedStartDate != "" ? this.selectedStartDate : "";
    },
  },
  watch: {
    reusePlan: async function (newVal, oldVal) {
      if (newVal == true) {
        //Populamos el array de datos locales con los datos remotos
        // await this.populateLocalData(this.v_reusePlan.volumes);
        // //Una vez tenemos instanaciados los datos, procedemos a calcular los porcentajes iniciales
        // await this.calculateInitialPercents();



      }
    },

    selectedStartDate: function (newVal, oldVal) {
      if (newVal) {
        return newVal;
      }
    },

  },
  methods: {
    //Importamos el método de vuex para actualizar los datos de volúmenes
    ...mapActions("planner", ["v_updCapacity"]),

    //Metodo de trigger Pouplate
    async populateFromExt(data) {
      //Usamos la función creada para ordenar los embalses de acuerdo al standar de Emasesa
      data = this.orderEmbalses(data, this.list, 'Nombre_Embalse');
      await this.populateLocalData(this.copyObject(data));
      //console.log(data);
      //Una vez tenemos instanaciados los datos, procedemos a calcular los porcentajes iniciales
      await this.calculateInitialPercents();
    },

    /**
     * Método para sustituir los datos locales (test) por los datos remotos
     * @param {Object} data Datos remotos provenientes de la base de datos
     */
    async populateLocalData(data) {
      const capacidades = [
        128.650,    // Aracena
        175.270,    // Zufre
        57.800,    // La Minilla
        58.800,    // Cala
        35.040,    // El Gergal
        185.600    // Los Melonares
      ];
      if (data) {
        //Recorremos array de datos remotos
        let i = 0;
        for await (let item of data) {
          item.capacidad = parseFloat(item.Capacidad)
          if (isNaN(item.capacidad)) {
            item.capacidad = capacidades[i]
          }
          i = i + 1;
        }
        this.datos = data
        //console.log('datos = data --> ', this.datos);
      }
    },

    //Método para calcular los porcentajes iniciales
    calculateInitialPercents() {
      for (let index = 0; index < this.datos.length; index++) {
        // IDs dinámicos basados en index
        const volMinElement = document.getElementById(`${this.id}-volMinPercent-${index}`);
        const volMaxElement = document.getElementById(`${this.id}-volMaxPercent-${index}`);
        const volMinUtilElement = document.getElementById(`${this.id}-volMinUtilPercent-${index}`);

        // Validar existencia de cada elemento antes de asignar valores
        if (volMinElement) {
          volMinElement.value = (
            (this.datos[index][this.selectedStartDate].volMin / this.datos[index].capacidad) *
            100
          ).toFixed(3);
        } else {
          console.error(`Elemento volMin con ID ${this.id}-volMinPercent-${index} no encontrado`);
        }

        if (volMaxElement) {
          volMaxElement.value = (
            (this.datos[index][this.selectedStartDate].volMax / this.datos[index].capacidad) *
            100
          ).toFixed(3);
        } else {
          console.error(`Elemento volMax con ID ${this.id}-volMaxPercent-${index} no encontrado`);
        }

        if (volMinUtilElement) {
          volMinUtilElement.value = (
            (this.datos[index][this.selectedStartDate].volMinUtil / this.datos[index].capacidad) *
            100
          ).toFixed(3);
        } else {
          console.error(`Elemento volMinUtil con ID ${this.id}-volMinUtilPercent-${index} no encontrado`);
        }
      }

      // Actualizar Vuex si es necesario
      /// this.v_updVolumes(this.datos);
      // this.$emit('updateVolumesValues', index, this.selectedStartDate, this.datos[index][this.selectedStartDate]);
    },


    /**
     * Método para calcular el volumen máximo o mínimo en función del porcentaje máximo o mínimo
     * (Asociado al evento input de los porcentajes)
     * @param {Number} index índice del array de datos que hay que modificar
     * @param {String} mode  Indica el tipo de volumen a modificar:
 *   - "max" para modificar el volumen máximo.
 *   - "min" para modificar el volumen mínimo.
 *   - "min_util" para modificar el volumen promedio.
     * @param {InputEvent} e evento de tipo input
     */
    calculateVol(index, mode, e) {

      // Primero detectamos si se ha introducido un caracter prohibido
      if (!this.isForbiddenChar(e.data)) {


        // Guardamos el valor del input en una variable local al método
        let percent = Number.parseFloat(e.target.value.replace(',', '.')); // Asegurarnos de que coma se reemplaza por punto

        // Comprobamos que el dato sea numérico
        if (!isNaN(percent)) {
          // Comprobamos que el porcentaje no supere 100
          if (percent > 100) {
            percent = 100;
            e.target.value = "100";
          }

          let capacidad = this.datos[index].capacidad; // Capacidad del embalse

          // Solo si el modo es correcto actualizamos los volúmenes
          if (mode === "volMax") {
            this.datos[index][this.selectedStartDate].volMax = parseFloat(((capacidad * percent) / 100).toFixed(3));
          } else if (mode === "volMin") {
            this.datos[index][this.selectedStartDate].volMin = parseFloat(((capacidad * percent) / 100).toFixed(3));
          } else if (mode === "volMinUtil") {
            this.datos[index][this.selectedStartDate].volMinUtil = parseFloat(((capacidad * percent) / 100).toFixed(3));
          }

          // Aseguramos que no se queden valores NaN en los volúmenes
          if (isNaN(this.datos[index][this.selectedStartDate][mode])) {
            this.datos[index][this.selectedStartDate][mode] = 0;
          }
          //console.log("slfj", this.datos, index, mode)
          // Emitir evento para actualizar el modelo
          this.$emit('updateVolumesValues', index, this.selectedStartDate, this.datos[index][this.selectedStartDate]);
        } else {
          // Si no es válido, limpiamos
          e.target.value = '';

        }
      }
    }
    ,

    /**
     * Método para calcular el porcentaje máximo o mínimo en función del volumen máximo o mínimo
     * (Asociado al evento input de los volúmenes)
     * @param {Number} index índice del array de datos que hay que modificar
     * @param {String} mode  Indica el tipo de volumen a modificar:
 *   - "max" para modificar el volumen máximo.
 *   - "min" para modificar el volumen mínimo.
 *   - "min_util" para modificar el volumen promedio.
     * @param {InputEvent} e evento de tipo input
     */
    calculatePercent(index, mode, e) {
      //console.log(`calculatePercent ejecutado con index: ${index}, mode: ${mode}`);

      // Reemplazar coma por punto
      let inputValue = e.target.value.replace(',', '.');
      //console.log(`Valor después de reemplazar coma por punto: ${inputValue}`);

      // Convertir el valor a número
      let volume = inputValue;

      if (!isNaN(volume)) {
        let capacidad = parseFloat(this.datos[index].capacidad);
        //console.log(`Capacidad del embalse: ${capacidad}`);

        // Limitar el volumen al valor de la capacidad
        if (volume > capacidad) {
          volume = capacidad; // Ajustar el volumen a la capacidad
          e.target.value = capacidad.toString(); // Convertir el volumen ajustado para mostrarlo con coma
        }

        // Actualizar el volumen en el modelo de Vue
        switch (mode) {
          case 'volMin':
            this.datos[index][this.selectedStartDate].volMin = volume;
            //console.log(`Volumen mínimo actualizado: ${volume}`, this.datos[index], this.selectedStartDate);
            // Calcular el porcentaje de volMin
            let volMinPercent = ((volume / capacidad) * 100).toFixed(3);
            //console.log(`Porcentaje de volMin calculado: ${volMinPercent}%`);

            // Actualizar el porcentaje de volMin
            this.datos[index][this.selectedStartDate].volMinPercent = volMinPercent;

            // Actualizar el campo de porcentaje en la interfaz
            this.$nextTick(() => {
              document.getElementById(`${this.id}-volMinPercent-${index}`).value = volMinPercent;
            });
            break;

          case 'volMax':
            this.datos[index][this.selectedStartDate].volMax = volume;

            // Calcular el porcentaje de volMax
            let volMaxPercent = ((volume / capacidad) * 100).toFixed(3);
            //console.log(`Porcentaje de volMax calculado: ${volMaxPercent}%`);

            // Actualizar el porcentaje de volMax
            this.datos[index][this.selectedStartDate].volMaxPercent = volMaxPercent;

            // Actualizar el campo de porcentaje en la interfaz
            this.$nextTick(() => {
              document.getElementById(`${this.id}-volMaxPercent-${index}`).value = volMaxPercent;
            });
            break;
          case 'volMinUtil':
            this.datos[index][this.selectedStartDate].volMinUtil = volume;

            // Calcular el porcentaje de volMinUtil
            let volMinUtilPercent = ((volume / capacidad) * 100).toFixed(3);
            //console.log(`Porcentaje de volMinUtil calculado: ${volMinUtilPercent}%`);

            // Actualizar el porcentaje de volMinUtil
            this.datos[index][this.selectedStartDate].volMinUtilPercent = volMinUtilPercent;

            // Actualizar el campo de porcentaje en la interfaz
            this.$nextTick(() => {
              document.getElementById(`${this.id}-volMinUtilPercent-${index}`).value = volMinUtilPercent;
            });
            break;

          default:
            console.error(`Modo inválido: ${mode}`);
            break;
        }


        // Emitir evento de actualización
        this.$emit('updateVolumesValues', index, this.selectedStartDate, this.datos[index][this.selectedStartDate]);
      } else {
        // Limpiar el campo si el valor no es válido
        e.target.value = '';
        this.datos[index][this.selectedStartDate].volMin = null;
        this.datos[index][this.selectedStartDate].volMinPercent = null;
      }
    }




    ,

    resetValue(index, mode) {
      this.datos[index][this.selectedStartDate][mode] = null;
    }
    ,
    checkEmptyPercent(index, mode, e) {
      //Realizamos la comprobacion del valor del input
      if (e.target.value == "" || isNaN(e.target.value)) {
        //Lo establecemos a cero
        e.target.value = 0;
        //Cambiamos el valor del dato local dependiendo del modo
        // if (mode) {
        //   this.datos[index][this.selectedStartDate].volMax = 0;
        // } else {
        //   this.datos[index][this.selectedStartDate].volMin = 0;
        // }
        switch (mode) {
          case "volMax":
            this.datos[index][this.selectedStartDate].volMax = 0;
            break;
          case "volMin":
            this.datos[index][this.selectedStartDate].volMin = 0;
            break;
          case "volMinUtil":
            this.datos[index][this.selectedStartDate].volMinUtil = 0;
            break;
          default:
            console.error(`Modo inválido: ${mode}`);
        }
        //Actualizamos el contenedor de VUEX
        ///this.v_updVolumes(this.datos);
        //console.log(this.datos, "v_volumes");
        this.$emit('updateVolumesValues', index, this.selectedStartDate, this.datos[index][this.selectedStartDate])
      }
    },
    /**
     * Método para comprobar que no se envíen cadenas vacías en el volumen y resetear el porcentaje en dicho caso
     * (Asociado al evento blur de los volumenes)
     * @param {Number} index índice del array de datos que hay que modificar
     * @param {String} mode  Indica el tipo de volumen a modificar:
 *   - "max" para modificar el volumen máximo.
 *   - "min" para modificar el volumen mínimo.
 *   - "min_util" para modificar el volumen promedio.
     * @param {FocusEvent} e evento de tipo blur
     */
    checkEmptyVolume(index, mode, e) {
      //Realizamos la comprobacion del valor del input
      if (e.target.value == "" || isNaN(e.target.value)) {
        //Lo establecemos a cero
        e.target.value = 0;
        //Cambiamos el valor del porcentaje asociado y el dato local dependiendo del modo
        // if (mode) {
        //   this.datos[index][this.selectedStartDate].volMax = 0;
        //   document.getElementById(`${this.id}-volMaxPercent-${index}`).value = 0;
        // } else {
        //   this.datos[index][this.selectedStartDate].volMin = 0;
        //   document.getElementById(`${this.id}-volMinPercent-${index}`).value = 0;
        // }

        switch (mode) {
          case "volMax":
            this.datos[index][this.selectedStartDate].volMax = 0;
            document.getElementById(`${this.id}-volMaxPercent-${index}`).value = 0;
            break;
          case "volMin":
            this.datos[index][this.selectedStartDate].volMin = 0;
            document.getElementById(`${this.id}-volMinPercent-${index}`).value = 0;
            break;
          case "volMinUtil":
            this.datos[index][this.selectedStartDate].volMinUtil = 0;
            document.getElementById(`${this.id}-volMinUtilPercent-${index}`).value = 0;
            break;
          default:
            console.error(`Modo inválido: ${mode}`);
        }
        //Actualizamos el contenedor de VUEX
        ///this.v_updVolumes(this.datos);
        //console.log(this.v_volumes);
        this.$emit('updateVolumesValues', index, this.selectedStartDate, this.datos[index][this.selectedStartDate])
      }
    },
    /**
     * Método para realizar los cambios de estilos relacionados con las COLUMNAS de la tabla
     * (Asociado a los eventos mouseenter y mouseleave de todos los elementos de tipo celda)
     * @param {Number} index índice de la columna a la que hay que aplicar estilos
     * @param {Boolean} mode  Indica el tipo de volumen a modificar:
 *   - "max" para modificar el volumen máximo.
 *   - "min" para modificar el volumen mínimo.
 *   - "min_util" para modificar el volumen promedio.
     */
    columnHover(index, mode) {
      //Obtención de elementos de columna según el índice
      let hoveredEmbalse = document.getElementById(`${this.id}-embalse-${index}`);
      let hoveredCapacidad = document.getElementById(`${this.id}-capacidad-${index}`);
      let hoveredVolMin = document.getElementById(`${this.id}-volMin-${index}`);
      let hoveredVolMax = document.getElementById(`${this.id}-volMax-${index}`);
      //Dependiendo de si entramos o salimos de la celda aplicamos unos estilos u otros
      if (mode) {
        hoveredEmbalse.style.color = "rgb(255, 255, 255)";
        hoveredEmbalse.style.backgroundColor = "rgb(39, 72, 129)";
        hoveredCapacidad.style.backgroundColor = "#ececec";
        hoveredVolMin.style.backgroundColor = "#ececec";
        hoveredVolMax.style.backgroundColor = "#ececec";
      } else {
        hoveredEmbalse.style.color = "rgb(255, 255, 255)";
        hoveredEmbalse.style.backgroundColor = "rgb(105, 107, 124)";
        hoveredCapacidad.style.backgroundColor = "rgb(255, 255, 255)";
        hoveredVolMin.style.backgroundColor = "rgb(255, 255, 255)";
        hoveredVolMax.style.backgroundColor = "rgb(255, 255, 255)";
      }
    },

    //Método que determina si un caracter es o no prohibido
    isForbiddenChar(char, value) {
      // Si la tecla es "Backspace" o "Delete", siempre es válida
      if (char === null || char === "Backspace" || char === "Delete") {
        return false; // Permitir borrar
      }

      // Los caracteres permitidos son dígitos o un solo punto decimal
      const allowedChars = /^[0-9.]$/;

      // Comprobamos si el carácter es válido
      if (!allowedChars.test(char)) {
        return true; // Si el carácter no es válido, lo prohibimos
      }

      // Verificar si ya existe un punto en el valor actual
      if (char === '.' && value.includes('.')) {
        return true; // Si ya hay un punto, prohibimos otro
      }

      return false; // Si todo está bien, el carácter es permitido
    }

    ,

    //Funcion para copiar el objeto y que se deslinke la misma referencia en memoria
    copyObject(obj) {
      return JSON.parse(JSON.stringify(obj));
    },
    //Función que recibe un array de objetos para ordenar, un array que contiene el orden deseado, y el nombre del 
    //atributo del objeto por el que se quiere ordenar. Devuelve un array ordenado.
    orderEmbalses(array, order, key) {
      array.sort(function (a, b) {
        var A = a[key], B = b[key];
        if (order.indexOf(A) > order.indexOf(B)) {
          return 1;
        } else {
          return -1;
        }
      });
      return array;
    }
  },
  async mounted() { 
    this.calculateInitialPercents();
  },
};
</script>

<style scoped>
/* Clase para que las anotaciones tengan el mismo estilo que los Select*/
.form-label {
  font-size: 0.875rem;
  font-weight: 500;
  color: #333333;
}

/* Inicio de estilos de la tabla personalizada*/
/* Se quitan los bordes de la primera celda*/

.table-custom .no-line {
  border: none;
  background-color: white;
}

/*Estilos de las cabeceras*/
.table-custom th {
  font-size: 10pt;
  background-color: rgb(105, 107, 124);
  color: rgb(255, 255, 255);
}

/*Estilos de las filas pares e impares para hacer striped*/
/*
.table-custom tbody tr:nth-child(odd) {
  background-color: rgb(255, 255, 255);
}
.table-custom tbody tr:nth-child(even) {
  background-color: rgb(244, 244, 244);
}
*/
/*Hover para cambiar la cabecera de las filas*/
.table-custom tbody tr:hover>th {
  color: rgb(255, 255, 255);
  background-color: rgb(39, 72, 129);
}

.table-custom thead tr>th {
  border: 1px solid #ccc;
}

.table-custom tbody tr>th {
  border: 1px solid #ccc;
}

.table-custom tbody {
  border-top: 1px;
}

.table-custom tbody tr>td {
  border: 1px solid #ccc;
}

/* Clase para los inputs de la tabla */
.inputVolume {
  width: 85px;
}

/* Hover para los inputs de la tabla */
.inputVolume:hover {
  box-shadow: 0 0 20px rgb(68, 99, 255);
}

/* Clase para poner el cursor en default */
.cursor-default {
  cursor: default;
}

.dateStartCell {
  background-color: #d9d7d7 !important;
  font-family: "Trebuchet MS", "Lucida Sans Unicode", "Lucida Grande",
    "Lucida Sans", Arial, sans-serif;
  font-size: 0.9rem;
}
</style>